module.exports = __webpack_public_path__ + "img/17.2fac44a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/17.png
// module id = DX4M
// module chunks = 1